import { render, staticRenderFns } from "./message-tip.vue?vue&type=template&id=b23c3600&scoped=true"
import script from "./message-tip.vue?vue&type=script&lang=ts"
export * from "./message-tip.vue?vue&type=script&lang=ts"
import style0 from "./message-tip.vue?vue&type=style&index=0&id=b23c3600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23c3600",
  null
  
)

export default component.exports